/*
 * @Description: user mutations type
 */

export enum UserMutationTypes {
  SET_TOKEN = 'SET_TOKEN',
  SET_INFO = 'SET_INFO',
  SET_ROLES = 'SET_ROLES',
  SET_MENU = 'SET_MENU',
  SET_PERMISSION = 'SET_PERMISSION'
}
